import { render, staticRenderFns } from "./ImportTaskDescriptor.vue?vue&type=template&id=0db3aa64&scoped=true&"
import script from "./ImportTaskDescriptor.vue?vue&type=script&lang=ts&"
export * from "./ImportTaskDescriptor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db3aa64",
  null
  
)

export default component.exports